import apiClient from '../apiClient'

// 이력서 상태 코드
const RESUME_STATUS = {
  ACTIVE: true,
  INACTIVE: false,
}

const resumeAPI = {
  // 이력서 목록 조회
  getResumes: (page, limit) =>
    apiClient.get('/resume', {
      params: {
        page,
        limit,
      },
    }),

  // 이력서 상세 조회
  getResumeDetail: id => apiClient.get(`/resume/${id}`),

  // 이력서 상태 업데이트
  updateStatus: (id, is_active) =>
    apiClient.post(`/resume/${id}/status`, {
      is_active,
    }),

  // 이력서 생성
  createResume: formData =>
    apiClient.post('/resume', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }),

  // 이력서 수정
  updateResume: (id, formData) =>
    apiClient.put(`/resume/${id}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }),

  // 이력서 삭제
  deleteResume: id => apiClient.delete(`/resume/${id}`),

  // S3 파일 다운로드
  downloadS3File: (fileName, uploadYear) =>
    apiClient.get(`/resume/download/s3`, {
      params: {
        file_name: fileName,
        upload_year: uploadYear,
      },
      responseType: 'blob',
    }),

  // 상태 코드 상수 export
  RESUME_STATUS,
}

export default resumeAPI
